import view from './view.html';

export default function () {
	return {
		replace:                    true,
		template:                   view,
		controller: /* @ngInject */ ($scope, AuthService) => {
			$scope.AuthService = AuthService;
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/navbar/supportWorker/index.js